import { useCallback, useContext } from 'react';
import { I18NContext } from './i18n';

import './I18nSwitch.scss';

export function I18nSwitch() {
    const { lang, setLang } = useContext(I18NContext);

    const onClick = useCallback(() => {
        setLang(prev => prev === 'hu' ? 'en' : 'hu');;
    }, [setLang]);

    return <button
        className={['lang-switch', lang === 'hu' ? 'en' : 'hu'].join(' ')}
        onClick={onClick}
    >{lang === 'hu' ? 'EN' : 'HU'}</button>
}
